export default "__VITE_ASSET__4ca2661e__"